<template>
    <v-app id="login">
        <router-view/>
        <v-row no-gutters>
            <v-col lg="3">
                <div id="leftSide" :style="`background-image: url(${securityStore.getImageLink()}/login-image.jpg)`"></div>
            </v-col>
            <v-col lg="3" md="2"></v-col>
            <v-col lg="3" md="5">
                <div id="rightSide">
                    <v-card color="basil">
                        <v-card-title class="text-center justify-center py-6">
                            <h1 class="font-weight-bold display-3 basil--text">
                                {{ $t("app_name") }}
                            </h1>
                        </v-card-title>
                        
                        <v-tabs
                            v-model="tab"
                            background-color="transparent"
                            color="basil"
                            grow
                        >
                            <v-tab key="k1" href="#k1"> Authentification</v-tab>
                            <!--<v-tab key="k2" href="#k2"> Dossiers</v-tab>-->
                        </v-tabs>
                        
                        <v-tabs-items v-model="tab">
                            <v-tab-item key="k1" value="k1">
                                <v-card color="basil" flat>
                                    <v-card-text>
                                        <v-row justify="center" align="center">
                                            <h1>
                                                <strong>Bienvenue</strong>
                                            </h1>
                                        </v-row>
                                        <br/>
                                        <br/>
                                        <v-row justify="center" align="center">
                                            <h5>
                                                <strong>Sign in to your account</strong>
                                            </h5>
                                        </v-row>
                                        <v-row justify="center">
                                            <v-col cols="12">
                                                <v-text-field
                                                    v-model="login.username"
                                                    label="Nom d'utilisateur"
                                                    append-icon="mdi-email-outline"
                                                    outlined
                                                    :color="inputColor"
                                                    :background-color="backgroundColor"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12">
                                                <v-text-field
                                                    v-model="login.password"
                                                    label="Mot de passe"
                                                    append-icon="mdi-key"
                                                    outlined
                                                    type="password"
                                                    @keyup.enter="authenticate"
                                                    :color="inputColor"
                                                    :background-color="backgroundColor"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row justify="center">
                                            <v-col md="10">
                                                <v-btn
                                                    color="teal lighten-1"
                                                    dark
                                                    @click="authenticate"
                                                    block
                                                    large
                                                    :loading="loading"
                                                >Connecter
                                                </v-btn
                                                >
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-tab-item>
                            <!--<v-tab-item key="k2" value="k2">
                                <v-card color="basil" flat>
                                    <v-card-text>
                                        <v-virtual-scroll
                                            :items="folderStore.folders"
                                            :item-height="50"
                                            height="300"
                                        >
                                            <template v-slot:default="{ item }">
                                                <v-list-item
                                                    @click="$router.push({name: 'login.folders.open',params: { folder_name: item.name }})"
                                                >
                                                    <v-list-item-title>
                                                        <strong>{{ item.name }}</strong>
                                                    </v-list-item-title>

                                                </v-list-item>
                                            </template>
                                        </v-virtual-scroll>
                                    </v-card-text>
                                </v-card>
                            </v-tab-item>-->
                        </v-tabs-items>
                    </v-card>
                </div>
            </v-col>
            <v-col lg="3" md="2"></v-col>
        </v-row>
    </v-app>
</template>

<script>
import {useSecurityStore} from "@/stores/Security.js";
import {useFolderStore} from "@/stores/Folder.js";
import {ref} from "vue";
import axios from "axios";
import useTools from "@/use/Tools";
import useSharedData from "@/use/SharedData";

export default {
    setup() {
        const {inputColor, backgroundColor} = useSharedData();
        const securityStore = useSecurityStore();
        const folderStore = useFolderStore();
        const {$router} = useTools();
        
        const login = ref({});
        const loading = ref(false);
        const tab = ref("k1");
        
        function authenticate() {
            loading.value = true;
            axios.post('/auth/signin', login.value).then((response) => {
                let jwtResponse = response.data;
                let accessToken = `${jwtResponse.type} ${jwtResponse.token}`;
                
                securityStore.setAccessToken(accessToken);
                window.localStorage.setItem("accessToken", accessToken);
                
                let userContext = jwtResponse.user;
                
                securityStore.setUserContext(userContext);
                window.localStorage.setItem("userContext", JSON.stringify(userContext));
                
                securityStore.setAuthorities(jwtResponse.authorities);
                window.localStorage.setItem("authorities", JSON.stringify(jwtResponse.authorities));
                
                let version = jwtResponse.version;
                securityStore.setVersion(version);
                window.localStorage.setItem("version", version);
                
                let serverAddress = jwtResponse.serverAddress;
                securityStore.setServerAddress(serverAddress);
                window.localStorage.setItem("serverAddress", serverAddress);
                
                let serverPort = jwtResponse.serverPort;
                securityStore.setServerPort(serverPort);
                window.localStorage.setItem("serverPort", serverPort);
                
                if (securityStore.userContext.needToChangePassword) {
                    $router.push({name: "reset_password"});
                } else {
                    // findAllFolders();
                    // tab.value = "k2";
                    // ✅ Read the saved route, fallback to notifications
                    const redirectTo = window.localStorage.getItem('redirectAfterLogin') || '/notifications'
                    window.localStorage.removeItem('redirectAfterLogin') // clean up
                    $router.push(redirectTo)
                }
            }).finally(() => {
                loading.value = false;
            });
        }
        
        // const loadingFolders = ref(false);
        
        /*function findAllFolders() {
            loadingFolders.value = true;
            axios.get('/folders', {params: {allRecords: true,}}).then(response => {
                folderStore.setFolders(response.data);
            }).finally(() => {
                loadingFolders.value = false;
            });
        }*/
        
        
        return {
            inputColor,
            backgroundColor,
            securityStore,
            folderStore,
            loading,
            tab,
            login,
            authenticate,
        }
    },
};
</script>

<style scoped>
#login {
    background-color: #f2f5f8;
}

#leftSide {
    min-height: 100vh;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    background-image: url("https://png.pngtree.com/thumb_back/fw800/back_our/20190620/ourmid/pngtree-mobile-banking-app-welcome-page-startup-page-h5-background-psd-image_153932.jpg");
}

#rightSide {
    min-height: 60%;
    background-position: center;
    margin-top: 40%;
}
</style>
